/* LucyBalu MW 21.10.26: „Passt perfekt dazu“ (snippets/lb-upsell.liquid)
   - Variante wählen → Preis im Button passt sich an
   - Klick → Produkt direkt in den Warenkorb, Warenkorb-Zähler und Drawer-Inhalt werden aktualisiert
   - Drawer öffnet sich nur, wenn das Hauptprodukt bereits im Warenkorb liegt – sonst bleibt der Kunde auf der Seite */
(function () {
  if (window.lbUpReady) return;
  window.lbUpReady = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // Statuszeile: Erfolg nur für Screenreader, Fehler sichtbar
  function msg(box, text, isErr) {
    var el = box.querySelector('.lb-up__msg');
    if (!el) return;
    el.classList.toggle('is-err', !!isErr);
    el.textContent = text || '';
  }

  function init(box) {
    if (box.dataset.lbInit) return;
    box.dataset.lbInit = '1';
    var main = box.getAttribute('data-main');

    box.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-lb-up-sel]');
      if (!sel) return;
      var it = sel.closest('.lb-up__it');
      var opt = sel.options[sel.selectedIndex];
      var btn = it.querySelector('[data-lb-up-add]');
      btn.setAttribute('data-id', opt.value);
      btn.classList.remove('is-done');
      it.querySelector('[data-lb-up-p]').textContent = opt.getAttribute('data-p');
    });

    box.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lb-up-add]');
      if (!btn || btn.disabled) return;
      btn.disabled = true;
      btn.classList.add('is-busy');
      msg(box, '');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-id')), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          btn.classList.add('is-done');
          msg(box, box.getAttribute('data-done'));
          var ajax = window.PXUTheme && window.PXUTheme.jsAjaxCart;
          if (ajax && ajax.updateView) ajax.updateView();
          var hasMain = (cart.items || []).some(function (i) { return String(i.product_id) === main; });
          if (hasMain && ajax && ajax.showDrawer) ajax.showDrawer();
        })
        .catch(function (err) {
          msg(box, (err && (err.description || err.message)) || '', true);
        })
        .then(function () {
          btn.disabled = false;
          btn.classList.remove('is-busy');
        });
    });
  }

  function initAll() { document.querySelectorAll('[data-lb-up]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
